import gsap from 'gsap';

export const fadeOut = (element: Element) => {
  gsap.fromTo(
    element,
    { opacity: 1 },
    {
      opacity: 0,
      duration: 0.3,
      // onComplete: () => element.classList.add("hidden"), //TODO: Uncomment out later
    }
  );
};

export const fadeIn = (element: Element) => {
  gsap.fromTo(
    element,
    { opacity: 0 },
    {
      opacity: 1,
      duration: 0.3,
    }
  );
};
